export const GROUP_FILTERS = {
  LIST_TYPE_VALUE_ALL: "all",
  LIST_TYPE_VALUE_SHARED: "shared",
  LIST_TYPE_VALUE_SHARED_WITH_ME: "shared_with_me",
  LIST_TYPE_VALUE_NO_SHARED_WITH_ME: "not_shared",
};
